module.exports = __webpack_public_path__ + "img/1cced8e.png";